// src/App.js - Modified
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css'; // Keep this for global styles for other pages
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import ScheduailerPage from './components/ScheduailerPage';
import ScheduailerDemo from './components/ScheduailerDemo'; // <-- Import the new Demo component

// Footer component
function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer">
      © {currentYear} flavy.us | All rights reserved
    </footer>
  );
}

// HomePage component (remains the same)
function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <Projects />
      <Contact />
    </>
  );
}

function App() {
  return (
    <Router>
      {/*
        The <div className="App"> wrapper is now conditionally applied
        only to routes that need the fixed-width, centered layout
        (your marketing/portfolio pages).
      */}
      <Routes>
        <Route
          path="/"
          element={
            <div className="App"> {/* <--- Wrap ONLY the homepage content */}
              <Header />
              <main>
                <HomePage />
              </main>
              <Footer />
            </div>
          }
        />
        <Route
          path="/scheduailer"
          element={
            <div className="App"> {/* <--- Wrap ONLY the scheduailer marketing page */}
              <Header />
              <main>
                <ScheduailerPage />
              </main>
              <Footer />
            </div>
          }
        />
        {/*
          The /scheduailer/demo route renders ScheduailerDemo directly.
          This allows it to take full viewport width and manage its own layout
          without being constrained by the .App CSS rules.
        */}
        <Route path="/scheduailer/demo" element={<ScheduailerDemo />} />
      </Routes>
    </Router>
  );
}

export default App;